import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@web-chat-core/ui-kit';
import ModalOverlay from '@web-chat-core/ui-kit/core/ModalOverlay';
import { observer } from 'mobx-react-lite';
import { ModalName } from 'features/Modals/ModalProvider';
import { selectIsModalOpened } from 'state/selectors';
import { useModal } from 'useCase/modal/useModal';
import {
    CallNotStartedButton,
    CallNotStartedMessage,
    CallNotStartedModalBody,
    CallNotStartedModalContent,
    CallNotStartedModalFooter,
} from './view';

export const CallNotStartedModal = observer(() => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { closeModal } = useModal();
    const isOpen = selectIsModalOpened(ModalName.CALL_NOT_STARTED);

    const handleClose = useCallback(() => {
        closeModal();
    }, [closeModal]);

    if (!isOpen) {
        return null;
    }

    return (
        <ModalOverlay
            name="call-not-started-modal"
            onClick={handleClose}
            isNeedOverlay={true}
            overlayBackground={theme.root.colors.background['01Base']}
        >
            <CallNotStartedModalBody onClick={(event: React.MouseEvent) => event.stopPropagation()}>
                <CallNotStartedModalContent>
                    <CallNotStartedMessage variant="body3">
                        {t('vks_request_call_not_started_try_later')}
                    </CallNotStartedMessage>
                </CallNotStartedModalContent>
                <CallNotStartedModalFooter>
                    <CallNotStartedButton variant="primary" onClick={handleClose}>
                        {t('web_videoconference_AI_Assistant_onbording_button')}
                    </CallNotStartedButton>
                </CallNotStartedModalFooter>
            </CallNotStartedModalBody>
        </ModalOverlay>
    );
});
